import { Th } from 'layouts/tableLayout/_th'
import { Tr } from 'layouts/tableLayout/_tr'
import React from 'react'
import { Text } from 'common/text'

export const TheadByOrder = ({ ...props }) => {

  return (
    <Tr {...props} type="tHead">
      <Th className="commission-order-table__cell">Ngày</Th>
      <Th className="commission-order-table__cell">Mã đơn hàng</Th>
      <Th className="commission-order-table__cell">
        <Text as={'p'} style={{ width: '100%' }} fontWeight={600}>Doanh thu</Text>
        <Text as={'p'} style={{ width: '100%' }}>(Sau giảm giá)</Text>
      </Th>
      <Th className="commission-order-table__cell">ĐL cấp 2</Th>
      <Th className="commission-order-table__cell">
        <Text fontWeight={600}>Hoa hồng ĐL cấp 2</Text>
        <div className='commission-two-role'>
          <p>Manager set</p>
          <p>ĐLC1 set</p>
        </div>
      </Th>
      <Th className="commission-order-table__cell">Hoa hồng ĐLC1</Th>
      <Th className="commission-order-table__cell">Hoa hồng chênh lệch</Th>
      <Th className="commission-order-table__cell">Hoa hồng thực nhận</Th>
    </Tr>
  )
}
